import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const GsisInvitationCallback = () => {
    if (import.meta.env.MODE === "development") {
        window.serverData = {
            status: "success",
            data: {
                token:
                    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIwNjkyMTk2MDIiLCJ1c2VyX2lkIjoiOWM4MTc4NjItYjk4YS00Nzc0LWE1ZjMtNDE3YzkwNTdkNWYyIiwibmJmIjoxNzY0OTMzMTcxLCJleHAiOjE3NjQ5MzM0NzEsImlhdCI6MTc2NDkzMzE3MX0.dVPcAUy5dwKg7g3EmB1ezf1hiyU8B83dlzotBEjSgn8",
            },
        };
    }

    const [data] = useState(window.serverData || {});
    const navigate = useNavigate();

    useEffect(() => {
        if (data.status === "success") {
            navigate("/employee-amka-login");
        } else {
            navigate("/error");
        }
    }, [data]);

    return (
        <div>
            <p>Processing, please wait...</p>
        </div>
    );
};

export default GsisInvitationCallback;
